import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Button } from './ui/button';

const COOKIE_CONSENT_KEY = 'reco_pneus_cookie_consent';

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'refused');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-xl p-4 sm:p-6 shadow-xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon & Text */}
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-6 h-6 text-[#41DB23] flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-gray-900 font-bold text-sm mb-1">
                {t.cookies.title}
              </h4>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                {t.cookies.text}{' '}
                <Link
                  to="/politique-confidentialite"
                  className="text-[#41DB23] hover:underline"
                >
                  {t.cookies.privacyLink}
                </Link>
                {' '}&amp;{' '}
                <Link
                  to="/cookies"
                  className="text-[#41DB23] hover:underline"
                >
                  {t.cookies.cookieLink}
                </Link>
                .
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <Button
              onClick={handleRefuse}
              variant="outline"
              className="flex-1 sm:flex-none border-gray-300 text-gray-700 hover:bg-gray-50 text-sm py-2 px-4"
              data-testid="cookie-refuse-btn"
            >
              {t.cookies.refuse}
            </Button>
            <Button
              onClick={handleAccept}
              className="flex-1 sm:flex-none bg-[#41DB23] text-white hover:bg-[#38C41E] font-bold text-sm py-2 px-4"
              data-testid="cookie-accept-btn"
            >
              {t.cookies.accept}
            </Button>
          </div>

          {/* Close button */}
          <button
            onClick={handleRefuse}
            className="absolute top-2 right-2 sm:hidden p-2 text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
